export default "__VITE_PUBLIC_ASSET__cf18b55c__"